<template>
      <div
        class="modal trader-info mng-acc-modal"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Offer Send to Ecn</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
               <div class="bid-dtl">
                <div class="outstanding" v-bind:class="{ 'width100': offerSenttoEcn.oldOffer && offerSenttoEcn.oldOffer.id == offerSenttoEcn.newOffer.id }">
                  <div class="header">
                    <h4>NEW OFFER</h4>
                  </div>
                  <div class="body">
                    <div class="value" >Quantity : <span>{{offerSenttoEcn.newOffer.quantity}}</span></div>
                    <div class="value" >Price : <span>{{offerSenttoEcn.newOffer.price}}</span></div>
                    <div class="value" >Yield : <span>{{offerSenttoEcn.newOffer.yield}}</span></div>
                    <div class="value" >Status : <span>{{offerSenttoEcn.newOffer.status}}</span></div>
                    <div class="value" >Offer Type : <span>{{offerSenttoEcn.newOffer.offerType}}</span></div>
                    <div class="value" >Min Bal Remain : <span>{{offerSenttoEcn.newOffer.balance}}</span></div>
                    <div class="value" >Min : <span>{{offerSenttoEcn.newOffer.minimum}}</span></div>
                    <div class="value" >Inc : <span>{{offerSenttoEcn.newOffer.incrementVal}}</span></div>
                    <div class="value" >Cost : <span>{{offerSenttoEcn.newOffer.cost}}</span></div>
                    <div class="value" >TWR price : <span>{{offerSenttoEcn.newOffer.twdprice}}</span></div>
                    <div class="value" >TMC price : <span>{{offerSenttoEcn.newOffer.tmcprice}}</span></div>
                    <div class="value" >KBP price : <span>{{offerSenttoEcn.newOffer.ibpprice}}</span></div>
                    <div class="value" >Settlement Date : <span>{{ moment(offerSenttoEcn.newOffer.settlementDate).format("MM/DD/YYYY") }}</span></div>
                    <div class="value" v-if="accountList.length > 0" >TMC Account :  <span>{{getAccountName(offerSenttoEcn.newOffer.tmcBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">BondPoint Account : <span>{{getAccountName(offerSenttoEcn.newOffer.ibpBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">TradeWeb Account : <span>{{getAccountName(offerSenttoEcn.newOffer.twdBrokerAccountId)}}</span></div>
                  </div>
                </div>
                <div class="newbid offer" v-if="offerSenttoEcn.oldOffer && offerSenttoEcn.oldOffer.id != offerSenttoEcn.newOffer.id">
                  <div class="header">
                    <h4>PRIORITY OFFER</h4>
                  </div>
                  <div class="body">
                    <div class="value" >Quantity : <span>{{offerSenttoEcn.oldOffer.quantity}}</span></div>
                    <div class="value" >Price : <span>{{offerSenttoEcn.oldOffer.price}}</span></div>
                    <div class="value" >Yield : <span>{{offerSenttoEcn.oldOffer.yield}}</span></div>
                    <div class="value" >Status : <span>{{offerSenttoEcn.oldOffer.status}}</span></div>
                    <div class="value" >Offer Type : <span>{{offerSenttoEcn.oldOffer.offerType}}</span></div>
                    <div class="value" >Min Bal Remain : <span>{{offerSenttoEcn.oldOffer.balance}}</span></div>
                    <div class="value" >Min : <span>{{offerSenttoEcn.oldOffer.minimum}}</span></div>
                    <div class="value" >Inc : <span>{{offerSenttoEcn.oldOffer.incrementVal}}</span></div>
                    <div class="value" >Cost : <span>{{offerSenttoEcn.oldOffer.cost}}</span></div>
                    <div class="value" >TWR price : <span>{{offerSenttoEcn.oldOffer.twdprice}}</span></div>
                    <div class="value" >TMC price : <span>{{offerSenttoEcn.oldOffer.tmcprice}}</span></div>
                    <div class="value" >KBP price : <span>{{offerSenttoEcn.oldOffer.ibpprice}}</span></div>
                    <div class="value" >Settlement Date : <span>{{ moment(offerSenttoEcn.newOffer.settlementDate).format("MM/DD/YYYY") }}</span></div>
                    <div class="value" v-if="accountList.length > 0" >TMC Account :  <span>{{getAccountName(offerSenttoEcn.oldOffer.tmcBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">BondPoint Account : <span>{{getAccountName(offerSenttoEcn.oldOffer.ibpBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">TradeWeb Account : <span>{{getAccountName(offerSenttoEcn.oldOffer.twdBrokerAccountId)}}</span></div>

                  </div>
                </div>
                <div class="newbid offer" v-if="offerSenttoEcn.sentECNOffer">
                  <div class="header">
                    <h4>OFFER IN ECN</h4>
                  </div>
                  <div class="body">
                    <div class="value" >Quantity : <span>{{offerSenttoEcn.sentECNOffer.quantity}}</span></div>
                    <div class="value" >Price : <span>{{offerSenttoEcn.sentECNOffer.price}}</span></div>
                    <div class="value" >Yield : <span>{{offerSenttoEcn.sentECNOffer.yield}}</span></div>
                    <div class="value" >Status : <span>{{offerSenttoEcn.sentECNOffer.status}}</span></div>
                    <div class="value" >Offer Type : <span>{{offerSenttoEcn.sentECNOffer.offerType}}</span></div>
                    <div class="value" >Min Bal Remain : <span>{{offerSenttoEcn.sentECNOffer.balance}}</span></div>
                    <div class="value" >Min : <span>{{offerSenttoEcn.sentECNOffer.minimum}}</span></div>
                    <div class="value" >Inc : <span>{{offerSenttoEcn.sentECNOffer.incrementVal}}</span></div>
                    <div class="value" >Cost : <span>{{offerSenttoEcn.sentECNOffer.cost}}</span></div>
                    <div class="value" >TWR price : <span>{{offerSenttoEcn.sentECNOffer.twdprice}}</span></div>
                    <div class="value" >TMC price : <span>{{offerSenttoEcn.sentECNOffer.tmcprice}}</span></div>
                    <div class="value" >KBP price : <span>{{offerSenttoEcn.sentECNOffer.ibpprice}}</span></div>
                    <div class="value" >Settlement Date : <span>{{ moment(offerSenttoEcn.sentECNOffer.settlementDate).format("MM/DD/YYYY") }}</span></div>
                     <div class="value" v-if="accountList.length > 0" >TMC Account :  <span>{{getAccountName(offerSenttoEcn.sentECNOffer.tmcBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">BondPoint Account : <span>{{getAccountName(offerSenttoEcn.sentECNOffer.ibpBrokerAccountId)}}</span></div>
                    <div class="value" v-if="accountList.length > 0">TradeWeb Account : <span>{{getAccountName(offerSenttoEcn.sentECNOffer.twdBrokerAccountId)}}</span></div>

                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-5" v-if="offerSenttoEcn.oldOffer && offerSenttoEcn.oldOffer.id != offerSenttoEcn.newOffer.id">
                <div class="p-2">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" v-model="pickedOption" value="NEW">
                    <label class="form-check-label" for="inlineRadio1">NEW OFFER</label>
                  </div>
                </div>
                <div class="p-2">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" v-model="pickedOption" value="EXISTING">
                    <label class="form-check-label" for="inlineRadio2">PRIORITY OFFER</label>
                  </div>
                </div>
              </div>
                <div class="modal-footer">
                  <button class="btn btn-light" type="button" @click="$emit('close')">Cancel</button>
                  <button class="btn btn-primary" v-if="offerSenttoEcn.oldOffer" type="button" @click="sentToEcn()">SEND TO ECN</button>
                  <button class="btn btn-primary" v-if="offerSenttoEcn.sentECNOffer" type="button"  @click="sentToEcn()">Cancel Outstanding Offer & Place New Offer </button>
                </div>
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
             
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
     import authService from "@/authService";
     import config from "@/config";

    export default {
        name: 'sentEcnModal',
         props: ['offerSenttoEcn'],
        components :{
            
        },
        data() {
            return {
               loading : false,
               pickedOption : "NEW",
               accountList : [],

            };
        },
        methods: {   
          sentToEcn(){
            let offerId = null;
            let cancelOfferId = "";
            //if(this.offerSenttoEcn.oldOffer){
              this.pickedOption == 'NEW' ? offerId = this.offerSenttoEcn.newOffer.id : offerId = this.offerSenttoEcn.oldOffer.id
            //}
            if(this.offerSenttoEcn.sentECNOffer){
              cancelOfferId = this.offerSenttoEcn.sentECNOffer.id || ""
            }
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
            .put(
                config.baseUrlBidSide + '/offer/sendtoecn?offeringId='+offerId+'&cancelOfferingIds='+cancelOfferId,
                  "",
                  auth
            )
            .then(() => {
              this.$alert("Offer send to Ecn's successfully","","success");
              this.$emit('close');  
            })
          },
          getBrokerAccountList(){
              const auth = {
                  headers: {'org-token' : authService.getOrgToken() }
              };
              this.$http
                  .get(
                  config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD",
                  auth
                  )
                  .then(response => {
                    this.accountList = response.data;
                  })
                  .catch(e => {
                  console.log(e);
                  });
          },
          getAccountName(id){
            console.log(id);
            return id ? this.accountList.find(x => x.id == id).account : 'N/A';
          },
         
        },
        mounted() {
          console.log(this.offerSenttoEcn)  ;
          this.getBrokerAccountList()

        }
    };
    </script>
    <style>
    .width100{
      width: 100% !important
    }
    </style>